// src/utils/firebase.ts

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, isSupported } from "firebase/analytics"; // ✅ Keep analytics support

// ✅ Your Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyDXs90RQYHFKuJisCq0ZyQRtYdBoyVCELY",
  authDomain: "thekarigarstop-92f1e.firebaseapp.com",
  projectId: "thekarigarstop-92f1e",
  storageBucket: "thekarigarstop-92f1e.appspot.com",
  messagingSenderId: "859521321508",
  appId: "1:859521321508:web:df7e20f2a691c05f3166b1",
  measurementId: "G-X9CCBJMSTH",
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Auth export
export const auth = getAuth(app);

// ✅ Firestore export
export const db = getFirestore(app);

// ✅ Optional Analytics (retain original lines)
export let analytics: ReturnType<typeof getAnalytics> | null = null;
isSupported().then((supported) => {
  if (supported && typeof window !== "undefined") {
    analytics = getAnalytics(app);
  }
});
